import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, getFormValues, change } from 'redux-form';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import _ from 'lodash';
import agent from '../../agent'
import Modal from 'react-responsive-modal';

import validate from '../registration/validate';

import ArrayCheckbox from "../ArrayCheckbox";
import NewAgency from '../NewAgency';
import AMLogo from '../../assets/images/Default Agency Logo.png';

import SelectComponent from '../ui/SelectComponent'
import CountryStates from '../../data/states';


const renderRepresentation = ({ input, onChange, meta: { touched, error } }) => (
  <div>
    <select {...input} selected={onChange} >
		<option value="">My Representation</option>
        <option value="freelance">Freelance</option>
	    <option value="represented">Represented</option>
    </select>
    { (touched && error) && <span className="form-error is-visible" id="uuid">{error}</span> }
  </div>
)

const renderSearchAgency = ({ input, className, placeholder, type, meta: { touched, error } }) => (
  	<div>
		<input {...input} placeholder={placeholder} type={type} />
		{ (touched && error) && <span className="form-error is-visible" id="uuid">{error}</span> }
	</div>
)


class RepresentationForm extends Component {
	state = {
		searchTerm: '',
		searchTimeout: {},
		isNewAgency: false,
		searchingAgency: false,
		toggleRepresentForm: false,
		showModalWarning: false,
		toogleAgencySelector: false
	}

	searchAgency = _.debounce( event => {
		if (event.target.value.length < 3) { return false }
		this.props.searchAgency(event.target.value, this.props.hasCountry);
	}, 1000)

	stateDetails(state, country) {
		return CountryStates.find(k => k.id === state && k.countryCode === country)
	}

	componentWillMount() {
		console.log('componentWillMount-represent', this.props)
		if (this.props.hidRepresent)
			this.props.submit();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.agency) {			
			this.props.change('artist[company_id]', nextProps.agency.id)
			this.props.change('agency', nextProps.agency)
			this.props.onSubmit(this.props.handleSubmit)
		}
	}

	onChangeRepresentation = (stateType, event, newValue) => {
		console.log('csd', stateType, event, newValue);

		if (newValue !== 'represented') {
			this.props.change('searchAgency', "")
			this.props.change('agency', "")
			this.props.change('artist[company_id]', "")
			this.setState({isNewAgency: false, toogleAgencySelector: false})
			this.props.clearAgencies()
		}
		if (newValue === 'represented') {
			this.setState({toogleAgencySelector: true})
		}
	
    }

	newAgency = (e) => {
		e.preventDefault();
		this.props.change('artist[company_id]', "")
		this.setState({isNewAgency: true});
	}

	onKeyPress = (event) => {
	    if (event.key === 13 /* Enter */) {
	      event.preventDefault();
	    }
	}

	submit = (values, dispatch, props) => {
		console.log('representation', props, values);

		if (values.representation === 'freelance') { props.submit() }
		if (values.representation === 'represented' && values.artist && values.artist.company_id) {
			props.onSubmit(props.handleSubmit);
			return
		}
		if (values.representation === 'represented' && values.agency) {
			// console.log('submit agency', values.agency);

			values.agency.email = values.agency.agent_email_address
			values.agency.contact_number = values.agency.agent_contact_number
			values.agency.website = ""

			var params = {
				agency: values.agency,
				artist_name: `${values.artist.first_name} ${values.artist.last_name}`,
				project_name: props.location.state.projectId.name,
				company_name: props.location.state.client.canonical_name
			}

			console.log('registerAgency', params)

			// this.props.registerAgency(params)
			props.registerAgency(params)
		}
	}

	changeRepresent = (flag) => {
		console.log('changeRepresent', flag)
		if (flag === 'SHOW')
			this.setState({ showModalWarning: true })
		if (flag === 'YES')
			this.setState({ showModalWarning: false, toggleRepresentForm: !this.state.toggleRepresentForm })
	}

	addDefaultSrc = (ev) => {
		console.log('Invoked missing image', ev.target.src)
	  ev.target.src = AMLogo
	}

	onCloseModal = () => {
		this.setState({ showModalWarning: false })
	}

  render() {
		const { handleSubmit, previousPage, representation, agencies = [], hidRepresent, location } = this.props
		const topPadding = {
			paddingTop: '2rem'
		}
		const leftMargin = {
			marginLeft: '1rem'
		}
		const fontSizeBig = {
			fontSize: '2rem',
			color: 'rgb(76, 175, 80)'
		}
		const fontColor = {
			color: 'rgb(76, 175, 80)',
			marginBottom: '0'
		}
		const fontSizeBigPen = {
			fontSize: '2rem',
			color: 'rgb(255, 152, 0)'
		}
		const fontColorPen = {
			color: 'rgb(255, 152, 0)',
			marginBottom: '0'
		}
		const under = {
			textDecoration: 'underline'
		}
		console.log('render-representation', this.props, representation, this.state.toogleAgencySelector)
		
		return (
		<div>
			<Modal classNames={{ modal: 'small-modal' }} open={this.state.showModalWarning} onClose={this.onCloseModal} little>
	          <h2 className="reveal-title">CHANGE REPRESENTATION ?</h2> 	          
	          <p>Are you sure you wish to change your representation to another agency/manager ? This will remove you from this agency and change your representation to this new agency, pending their verification.</p>
	          <div className="clearfix"></div>
	          <button className="button float-left" onClick={this.onCloseModal}>CANCEL</button>
	          <button style={leftMargin} className="button float-left" onClick={e => this.changeRepresent('YES')}>YES PROCEED</button>
	    	</Modal>
			<form onSubmit={handleSubmit} className="registartion-representation-form" id="reg-representation-form" >
				<section className="section gray-bg registration-details-area">
					<div className="grid-x align-center">
					{
						representation.representation === 'freelance' ?
							<div className="small-12 medium-10 large-8 cell">
								<div className="grid-x align-center">
									<div className="cell medium-3 represent-title">
										<p>Current Representation: </p>
									</div>
									<div className="cell medium-3 represent-value">
										<p>FREELANCE</p>
									</div>
								</div>
								<div style={topPadding} className="grid-x align-center">
									<button onClick={e => this.changeRepresent('SHOW')} className="button hollow warning">Change Representation</button>
								</div>
							</div> : 
						representation.representation === 'represented (unverified)' ?
							<div className="small-12 medium-10 large-8 cell">
								<div className="grid-x align-center">
									<div className="cell medium-3 small-9 represent-title">
										<p>Current Representation: </p>
									</div>
									<div className="cell medium-3 small-9 represent-value">
										<div className="grid-x align-middle">
											<i style={fontSizeBigPen} className="cell medium-2 small-2 fa fa-minus-circle" aria-hidden="true"></i>
											<p style={fontColorPen} className="cell medium-9 small-9">pending verification</p>
										</div>
									</div>
								</div>
								<div style={topPadding} className="grid-x align-center">
									<div className="cell medium-3 small-9 represent-title">
										<img src={representation.agency || AMLogo} />
									</div>
									<div className="cell medium-3 small-9 represent-value represent-value-fix">
										<div className="cell"><p>{representation.representation_request_info.company_name}</p></div>
										<div className="cell"><p>{representation.representation_request_info.address}</p></div>
										<div className="cell"><p style={under} className="margin-bottom-fix">{representation.representation_request_info.email}</p></div>
										<div className="cell"><p style={under}>{representation.representation_request_info.contact_number}</p></div>
									</div>
								</div>
								<div style={topPadding} className="grid-x align-center">
									<button onClick={e => this.changeRepresent('SHOW')} className="button hollow warning">Change Representation</button>
								</div>
							</div> : 
						<div className="small-12 medium-10 large-8 cell">
							<div className="grid-x align-center">
								<div className="cell medium-3 small-9 represent-title">
									<p>Current Representation: </p>
								</div>
								<div className="cell medium-3 small-9 represent-value">
									<div className="grid-x align-middle">
										<i style={fontSizeBig} className="cell medium-2 small-2 fa fa-check-circle-o" aria-hidden="true"></i>
										<p style={fontColor} className="cell medium-6 small-6">verified</p>
									</div>
								</div>
							</div>
							<div style={topPadding} className="grid-x align-center">
								<div className="cell medium-3 small-9 represent-title">
									<img src={representation.agency.logo_url || AMLogo} />
								</div>
								<div className="cell medium-3 small-9 represent-value represent-value-fix">
									<div className="cell"><p>{representation.agency.name}</p></div>
									<div className="cell"><p className="margin-bottom-fix">{representation.agency.address + '' + representation.agency.city}</p></div>
									<div className="cell"><p className="margin-bottom-fix">{this.stateDetails(representation.agency.state, representation.agency.country).name + '' + representation.agency.postal_code}</p></div>
									<div className="cell"><p>{representation.agency.country}</p></div>
									<div className="cell"><p style={under} className="margin-bottom-fix">{representation.agency.email}</p></div>
									<div className="cell"><p style={under}>{representation.agency.contact_number}</p></div>
								</div>
							</div>
							<div style={topPadding} className="grid-x align-center">
								<button onClick={e => this.changeRepresent('SHOW')} className="button hollow warning">Change Representation</button>
							</div>
						</div>
					}
					</div>
				</section>

				{
					this.state.toggleRepresentForm &&
					(<section className="section gray-bg">
						<div className="grid-x align-center">
						<div className="small-12 medium-10 large-8 cell">

							<div className="row">
								<div className="small-12 medium-8 medium-centered column">
									<Field 
										name="representation" 
										onChange={this.onChangeRepresentation.bind(this, "representation")}
										component={SelectComponent}
										validate={[value => !value && "Representation is required"]}
										placeholder="Please select representation"
										options={[{value: 'freelance', label: "Freelance"}, {value: 'represented', label: "Represented"}]} />
								</div>
							</div>
							
							{this.state.toogleAgencySelector && (
								<div className="row">
									<div className="small-12 medium-8 medium-centered column">
										<Field 
											name="searchAgency"
											component={renderSearchAgency}
											type="text"
											onChange={this.searchAgency}
											hasCountry={this.props.hasCountry}
											validate={[value => !value && "Please enter name of your agency"]}
											onKeyPress={this.onKeyPress}
											placeholder="Type agency / manager name and press enter"/>
									</div>
								</div>
							)}

							<div>

								{!this.state.isNewAgency && (
						            agencies.map( agency => {
						              return (
						                <div className="row representation-agency-list" key={agency.id}>
						                <div className="small-12 medium-8 medium-centered column">
						                <div className="row">
											<div className="small-3 column text-left">
												<img onError={this.addDefaultSrc} src={agency.logo_url || AMLogo} alt="" />	
											</div>
											<div className="small-6 column text-left">
												<div className="agency-name">{agency.name}</div>
											    <div className="agency-location">{agency.state_name}, {agency.country}</div>
											</div>
											<div className="small-3 column">
												<Field 
													name="artist[company_id]"
													itemValue={agency.id}
													component={ArrayCheckbox}
													/>
											</div>
										</div>
										</div>
										</div>
						              )
						            })
						        )}

						        {(representation.representation === 'represented' || representation.representation === 'represented (unverified)') 
						        	&& agencies.length > 0
						         	? 	<div className="row">
											<div className="samll-12 column">
											<p className="text-center">My agency/ management is not listed 
											<a className="primary" onClick={this.newAgency}> Click here</a></p>
											</div>
										</div>
									: ''
						        }

								
						        {this.state.isNewAgency && (representation.representation == 'represented' || 
						        	representation.representation === 'represented (unverified)') && (<NewAgency />)}

							</div>
					
						</div>
						</div>
					</section>)
				}

				<section className="section registration-action-buttons">
					<div className="grid-x align-center">
						<div className="small-12 cell text-center">
							<button className="button primary next" type="submit">Save</button>
						</div>
					</div>
				</section>
			</form>
		</div>
  		)
	}	
}

RepresentationForm = reduxForm({
  form: 'artistRegistrationWizard2', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(RepresentationForm)

const selector = formValueSelector('artistRegistrationWizard2')
const mapStateToProps = state => ({
	agency: state.artist.agency,
  agencies: state.artist.agencies,
  // representation: selector(state, 'representation'),
  registrationValues: getFormValues('artistRegistrationWizard2')(state),
  hasCountry: selector(state, 'artist[country]'),
});

const mapDispatchToProps = dispatch => ({
  registerAgency: agency => 
  	dispatch({ type: 'REGISTER_AGENCY', payload: agent.Agency.register(agency) }),
  searchAgency: (search, country) => 
  	dispatch({ type: 'SEARCH_AGENCY', payload: agent.Agency.search(search, country) }),
  clearAgencies: () => dispatch({type: 'CLEAR_AGENCIES'}),
  fieldChange: (type, value) => 
  	dispatch(change('artistRegistrationWizard', type, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(RepresentationForm);


// WEBPACK FOOTER //
// ./src/components/profile/RepresentationForm.js